export default "/_next/static/images/3a9958c66dfbb90ed9afafc7dc27f701.png";